import CardAlertBase from "./CardAlertBase";

export default CardAlertBase;
